import { render } from "./ChartOfAccount.vue?vue&type=template&id=44f9efc0&scoped=true"
import script from "./ChartOfAccount.vue?vue&type=script&lang=js"
export * from "./ChartOfAccount.vue?vue&type=script&lang=js"

import "./ChartOfAccount.vue?vue&type=style&index=0&id=44f9efc0&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44f9efc0"]])

export default __exports__